import { useGlobalContext } from "../../../../context/GlobalContext";
import { useCallback, useEffect } from "react";
import { useAulaService } from "../../../../services/aula.service";
import { useParams } from "react-router-dom";
import { useAulaInformacaoBoxStore } from "../../store/use-aula-informacao-box.store";
import { useTranslation } from "react-i18next";

export default function useAulaInformacaoBox() {
  const { id } = useParams();
  const { t } = useTranslation('gestao_de_aulas')
  const { setIsGlobalLoading } = useGlobalContext();
  const { findAulaInformacaoBox } = useAulaService();
  const { aulaInformacaoBox, setAulaInformacaoBox } =
    useAulaInformacaoBoxStore();

  const getAulaInformacaoBox = useCallback(async () => {
    if (!id) return;

    await findAulaInformacaoBox(parseInt(id)).then(({ data }) =>
      setAulaInformacaoBox(data),
    );
  }, [id]);

  useEffect(() => {
    const controller = new AbortController();

    setIsGlobalLoading(true);

    getAulaInformacaoBox().finally(() => setIsGlobalLoading(false));

    return () => controller.abort();
  }, [setIsGlobalLoading, getAulaInformacaoBox]);

  const alunoLabel = {
    0: t("gestao_de_aulas:noActiveStudents"),
    1: `${aulaInformacaoBox?.quantidadeAlunos} ${t("gestao_de_aulas:oneActiveStudent")}`,
  };

 const getQuantidadeAlunosLabel =
    alunoLabel[aulaInformacaoBox?.quantidadeAlunos] ||
    `${aulaInformacaoBox?.quantidadeAlunos} ${t("gestao_de_aulas:enrolledStudents")}`;


  return {
    getQuantidadeAlunosLabel,
    aulaInformacaoBox,
  };
}
